import FilesTenantView from './FilesTenantView'

export default FilesTenantView
